export function withErrorHandler(fn) {
  return async function(...args) {
    try {
      return await fn.apply(this, args);
    } catch (error) {
      let errorMessage = error.response?.data?.detail || "Internal server error";
      
      // Handle FastAPI validation errors (array format)
      if (Array.isArray(errorMessage) && errorMessage.length > 0) {
        errorMessage = errorMessage[0].msg || "Validation error";
      }
  
      error.message = errorMessage;
      throw error;
    }
  };
}
